var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "School" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 45, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "学校名称",
                            prop: "name",
                            "label-width": 75,
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "学校名称",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              model: {
                                value: _vm.search.name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.name",
                              },
                            },
                            _vm._l(_vm.schoolList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: { label: item.name, value: item.id },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleRemoteMethodChange(item)
                                  },
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(_vm.enums.status, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("\n              "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "5px",
                display: "flex",
                width: "100%",
              },
              attrs: { slot: "extra" },
              slot: "extra",
            },
            [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { size: "small", icon: "md-add", type: "primary" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("添加")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "singleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "name",
              label: "学校名称",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "type",
              label: "类型",
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.converType(row.type)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "gradeRange",
              label: "年级范围",
              "min-width": "130",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(row.lowGradeName + " -- " + row.higtGradeName)
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "otherGradeName",
              label: "其他年级",
              "min-width": "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "contactPerson",
              label: "联系人",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "telphone",
              label: "联系电话",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "address",
              label: "地址",
              "show-overflow-tooltip": "",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "updateTime",
              label: "最后操作时间",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "status",
              label: "状态",
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      on: {
                        change: function ($event) {
                          return _vm.handleEditStatus(row, null, row.status)
                        },
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "operation",
              label: "操作",
              "min-width": "60",
              id: "elPopoverVisible",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
      _c(
        "Modal",
        {
          attrs: {
            width: "50%",
            title: _vm.windowTitle,
            styles: { top: "60px" },
            "mask-closable": false,
          },
          model: {
            value: _vm.editWindow,
            callback: function ($$v) {
              _vm.editWindow = $$v
            },
            expression: "editWindow",
          },
        },
        [
          _c("SchoolEdit", {
            ref: "edit",
            on: { "on-submit": _vm.handleSubmit },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              ),
              _c(
                "Button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editWindow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }